import {RegistereRibbonButton, useRibbon} from "@eavfw/apps";
import React, {useState} from "react";
import {useBoolean} from "@fluentui/react-hooks";
import {
    Button,
    Dialog, DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger
} from "@fluentui/react-components";
import {Spinner} from "@fluentui/react";

RegistereRibbonButton("CUSTOM_EXTRACT_LOITEMPLATES_OVERVIEW", ({key, ...props}) => {
    const {registerButton} = useRibbon();

    const [hideDialog, {toggle: toggleHideDialog}] = useBoolean(true);
    const [isLoading, {toggle: doneLoading}] = useBoolean(true);
    const [downloadLink, setDownloadLink] = useState<string>("");
    const [isStarted, {toggle: toggleStarted}] = useBoolean(false);

    registerButton({
        key: key,
        text: props.text ?? "Run Workflow",
        iconProps: props.iconProps ?? {iconName: 'Send'},
        title: props.title ?? props.text ?? "Run Workflow",
        disabled: false,
        onClick: () => {
            toggleHideDialog();

            if (!isStarted) {
                console.log("[Downloader] Starting download...")
                toggleStarted();
                setTimeout(async (): Promise<void> => {
                    let workflowName: string = "DownloadLoiOverviewWorkflow";

                    let rsp = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/workflows/${workflowName}/runs`, {
                        method: "POST",
                        body: JSON.stringify({}),
                        credentials: "include"
                    });

                    let id = await rsp.json().then(x => x.id);

                    let completed = false;

                    while (!completed) {
                        let statusRsp = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/workflows/${workflowName}/runs/${id}/status`, {
                            credentials: "include"
                        });

                        let status = await statusRsp.json();
                        completed = status.completed;

                        await new Promise((resolve) => setTimeout(resolve, 5000));
                    }

                    console.log("[Downloader] Download complete")

                    let stateRsp = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/workflows/${workflowName}/runs/${id}`, {
                        credentials: "include"
                    });

                    let result = await stateRsp.json();

                    doneLoading()
                    setDownloadLink(`${process.env.NEXT_PUBLIC_API_BASE_URL}/files/${result.body.documentId}`)
                });
            } else {
                console.log("[Downloader] Already started")
            }
        }
    }, [hideDialog, isStarted, isLoading, downloadLink]);
    
    return <>
        <Dialog open={!hideDialog}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>Retrieving overview</DialogTitle>
                    <DialogContent>
                        Collecting Letter of Indemnity Template controls from the back-end
                    </DialogContent>
                    <DialogActions fluid>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary" onClick={toggleHideDialog}>Close</Button>
                        </DialogTrigger>
                        <Button
                            appearance="primary"
                            disabled={isLoading}
                            onClick={() => window.open(downloadLink, '_blank')}>
                            {isLoading ? <Spinner/> : 'Download'}
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    </>

    /*return <>
        <SimpleDialog title={"Retrieving overview"} hideDialog={hideDialog} toggleHideDialog={toggleHideDialog}>
            <Button disabled={isLoading}
            onClick={() => window.open(downloadLink, '_blank')}
            style={{ display: 'flex', justifyContent: 'center', marginBottom: 5 }}>
        {isLoading ? <Spinner/> : 'Download'}
    </Button>
        </SimpleDialog>
    </>*/
});
